import React, { useMemo } from 'react';

import { useHistoryOutcomeCardContext } from '../../contexts/HistoryOutcomeCardContext';
import useMergeProps from '../../hooks/useMergeProps';
import useTypedSelector from '../../hooks/useTypedSelector';

import HistoryItemOutcomeCardProgressBar from './HistoryItemOutcomeCardProgressBar';
import makeHistoryItemOutcomeCardProgressBarSelector from './HistoryItemOutcomeCardProgressBar.selector';

type HistoryItemOutcomeCardProgressBarContainerProps = {
  className?: string;
  outcomeId?: number;
};

const HistoryItemOutcomeCardProgressBarContainer = React.forwardRef<
  HTMLDivElement,
  HistoryItemOutcomeCardProgressBarContainerProps
>(function HistoryItemOutcomeCardProgressBarContainer(
  { outcomeId: outcomeIdFromProps, ...ownProps }: HistoryItemOutcomeCardProgressBarContainerProps,
  ref,
) {
  const { outcomeId: outcomeIdFromHistoryOutcomeCardContext } = useHistoryOutcomeCardContext();
  const outcomeId = useMemo(
    () => outcomeIdFromProps ?? outcomeIdFromHistoryOutcomeCardContext,
    [outcomeIdFromProps, outcomeIdFromHistoryOutcomeCardContext],
  );

  const selector = useMemo(() => makeHistoryItemOutcomeCardProgressBarSelector(), []);
  const selectorProps = useMemo(() => ({ outcomeId }), [outcomeId]);
  const { isVisible, ...selectedProps } = useTypedSelector((state) => selector(state, selectorProps));

  const { currentValue, threshold, ...enhancedProps } = useMergeProps({ ownProps, selectedProps });

  if (isVisible) {
    if (currentValue !== undefined && threshold !== undefined) {
      return (
        <HistoryItemOutcomeCardProgressBar
          {...enhancedProps}
          currentValue={currentValue}
          threshold={threshold}
          ref={ref}
        />
      );
    }
  }

  return null;
});

export default HistoryItemOutcomeCardProgressBarContainer;
